import React from 'react';

const ScaledLayout = ({ children, scale = 0.8 }) => {
  const outerStyle = {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  };

  const innerStyle = {
    transform: `scale(${scale})`,
    transformOrigin: 'top left',
    width: `${100 / scale}%`,
    height: `${100 / scale}%`,
    overflow: 'auto',
  };

  return (
    <div style={outerStyle}>
      <div style={innerStyle}>{children}</div>
    </div>
  );
};

export default ScaledLayout;
